import { utils, writeFile } from "xlsx";

import { FileColumnLabel } from "./stock-adjustment-file-constants";

const downloadSheet = (fileName, header, instructions) => {
  const dataSheet = utils.aoa_to_sheet([header]);
  dataSheet["!cols"] = header.map(() => ({ wch: 22 }));

  const instructionSheet = utils.aoa_to_sheet(instructions.map((line) => [line]));
  instructionSheet["!cols"] = [{ wch: 100 }];

  const workbook = utils.book_new();
  // The first sheet is the one that is read back, so the data sheet goes first.
  utils.book_append_sheet(workbook, dataSheet, "Template");
  utils.book_append_sheet(workbook, instructionSheet, "Petunjuk");
  writeFile(workbook, fileName);
};

export const downloadImportTemplate = () =>
  downloadSheet(
    "template-penyesuaian-stok.xlsx",
    [FileColumnLabel.sku, FileColumnLabel.quantity, FileColumnLabel.costPerUnit],
    [
      "Isi lembar Template, satu baris untuk satu SKU. Jangan mengubah judul kolom.",
      "SKU: satu SKU hanya boleh satu baris. Jika SKU berisi angka depan 0 (contoh 00123), format kolom sebagai Teks.",
      "Qty: bilangan bulat lebih dari 0.",
      "Harga per Unit: angka 0 atau lebih, tanpa pemisah ribuan. Contoh 15000 atau 15000,50.",
      "File .csv juga dapat dipakai dengan kolom yang sama.",
    ]
  );

export const downloadCostUpdateTemplate = () =>
  downloadSheet(
    "template-update-harga-penyesuaian-stok.xlsx",
    [FileColumnLabel.sku, FileColumnLabel.costPerUnit],
    [
      "Isi lembar Template, satu baris untuk satu SKU yang harganya diubah. Jangan mengubah judul kolom.",
      "Hanya Harga per Unit yang berubah. Qty tidak diubah, dan SKU yang tidak ada di file tetap seperti semula.",
      "Harga per Unit: angka 0 atau lebih, tanpa pemisah ribuan. Contoh 15000 atau 15000,50.",
    ]
  );

/** `errors` are `{ row, sku, message }`. */
export const downloadErrorList = (errors, fileName = "daftar-kesalahan.xlsx") => {
  const sheet = utils.aoa_to_sheet([
    ["Baris", "SKU", "Pesan"],
    ...errors.map(({ row, sku, message }) => [row ?? "", sku ?? "", message]),
  ]);
  sheet["!cols"] = [{ wch: 8 }, { wch: 24 }, { wch: 110 }];

  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, sheet, "Kesalahan");
  writeFile(workbook, fileName);
};
